	$(".link_locale").on('click', function(){
		console.log('open popup');
		var popupId = $(this).attr("data-popupid");
		$('section[data-popupid='+popupId+'] ').removeClass('hide').addClass('show');
		$('section[data-popupid='+popupId+'] ').find(".modale-partnership").show();
		$('section[data-popupid='+popupId+'] ').find('.modale-submit-ticketing').get(0).style.display = "block";
	});
	
	$(".close_popup").on('click', function(){
		console.log('close popup');
		var popupId = $(this).attr("data-popupid");
		$('section[data-popupid='+popupId+'] ').removeClass('show').addClass('hide');
		$('section[data-popupid='+popupId+'] ').find(".modale-partnership").hide();
	});


	$(".btn-popup").on('click', function(){
		console.log('close no click');
		var popupId = $(this).attr("data-popupid");
		$('section[data-popupid='+popupId+'] ').removeClass('show').addClass('hide');
		$('section[data-popupid='+popupId+'] ').find(".modale-partnership").hide();
	});


